import React from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './UserNotFound.module.scss'
import BackButton from '../../components/buttons/BackButton/BackButton'

export default function UserNotFound({ setPage }) {
	const navigate = useNavigate()

	return (
		<div className={styles.userNotFoundContainer}>
			<BackButton onBack={() => setPage(0)} />
			<div className={styles.notFoundForm}>
				<h2 className={styles.userNotFoundTitle}>계정/비밀번호 찾기</h2>

				<div className={styles.userNotFoundMessage}>일치하는 계정이 없어요</div>

				<button
					type="button"
					className={styles.userNotFoundLoginButton}
					onClick={() => navigate('/login')}>
					로그인하러 가기
				</button>

				<button
					type="button"
					className={styles.userNotFoundRegisterButton}
					onClick={() => navigate('/signup')}>
					회원가입
				</button>
			</div>
		</div>
	)
}
